import { Alert, Button, CircularProgress, MenuItem, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { getAdminDocumentAccess, setAdminDocumentAccess } from "features/company-documents/service/DocumentAccessService";

export default function CompanyDocumentAccessSettings({ adminId }) {
  const [access, setAccess] = useState(null);
  const [level, setLevel] = useState("NO_ACCESS");
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);
  useEffect(() => {
    let active = true;
    setLoading(true); setAccess(null); setSaved(false); setError("");
    getAdminDocumentAccess(adminId).then(value => {
      if (active) { setAccess(value); setLevel(value.level); }
    }).catch(e => active && setError(e.message)).finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [adminId]);
  const save = async () => {
    setBusy(true); setSaved(false); setError("");
    try {
      const value = await setAdminDocumentAccess(adminId, level);
      setAccess(value); setLevel(value.level); setSaved(true);
    } catch (e) { setError(e.message); }
    finally { setBusy(false); }
  };
  return <Stack spacing={2} sx={{ borderTop: "1px solid #CDD4D7", pt: 2 }}>
    <Typography fontWeight={600}>Company Documents Access</Typography>
    {error && <Alert severity="error">{error}</Alert>}
    {loading ? <CircularProgress size={20} /> : access?.can_manage && <>
      <TextField select label="Company Documents access level" value={level} disabled={busy}
        onChange={e => { setLevel(e.target.value); setSaved(false); }}>
        <MenuItem value="NO_ACCESS">No access</MenuItem>
        <MenuItem value="VIEW_ONLY" disabled={!access.eligible}>View Company Documents</MenuItem>
        <MenuItem value="REVIEWER" disabled={!access.eligible}>View and Review Company Documents</MenuItem>
      </TextField>
      <Typography variant="body2">Review access includes viewing, PDF preview, download and version history.</Typography>
      {!access.eligible && <Alert severity="info">Only active Admin accounts can receive document access. Existing grants can be revoked.</Alert>}
      <Button variant="outlined" onClick={save} disabled={busy}>Save document access</Button>
      {saved && <Alert severity="success">Company Documents access saved.</Alert>}
    </>}
  </Stack>;
}
